<template>
  <div style="padding: 1vw">
    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 0 1vw;
      "
    >
      <div class="pageTitle">
        <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
          {{ isDentalLaboratory ? "기공소" : "제조사" }} 관리 (등록
          {{ isDentalLaboratory ? "기공소" : "제조사" }} 수:
          {{ addCommaToNumber(listSize) }})
        </h3>
        <span class="pageDesc">
          우리 서비스를 사용하는
          {{ isDentalLaboratory ? "기공소" : "제조사" }}를 등록하고 관리할 수
          있습니다.
        </span>
      </div>
      <div style="display: flex; align-items: center">
        <button
          class="btn btn-primary"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#manufacturerInfoWModal"
        >
          등록하기
        </button>
      </div>
    </div>
    <div class="filterWrap" style="">
      <div class="searchdropbox">
        <select
          v-model="selectedAreaFirst"
          id="itemCode"
          @change="areaSecondChange()"
        >
          <option value="" selected>시/도 선택</option>
          <option v-for="item in areaFirst" :value="item" :key="item">
            {{ `${item}` }}
          </option>
        </select>
        <select
          v-model="selectedAreaSecond"
          id="itemCode"
          @change="areaThirdChange()"
        >
          <option value="" selected>시/군/구 선택</option>
          <option v-for="item in areaSecond" :value="item" :key="item">
            {{ `${item}` }}
          </option>
        </select>
        <select
          v-model="selectedAreaThird"
          id="itemCode"
          @change="
            () => {
              paginationData.currentPage = 1;
              getManufacturersList();
            }
          "
        >
          <option value="" selected>읍/면/동 선택</option>
          <option v-for="item in areaThird" :value="item" :key="item">
            {{ `${item}` }}
          </option>
        </select>
        <select v-model="deleteFilter" id="itemCode" @change="enter()">
          <option value="" selected>전체</option>
          <option value="N">
            삭제 안된 {{ isDentalLaboratory ? "기공소" : "제조사" }}만
          </option>
          <option value="Y">
            삭제된 {{ isDentalLaboratory ? "기공소" : "제조사" }}만
          </option>
        </select>
        <select
          v-model="registrationStatusFilter"
          id="itemCode"
          @change="enter()"
        >
          <option value="" selected>등록상태 전체</option>
          <option value="ACTIVE">활성</option>
          <option value="PENDING">승인대기</option>
          <option value="REJECTED">거절됨</option>
        </select>
        <button @click="initFilter()">옵션 초기화</button>
      </div>
      <div class="searchinputbox">
        <select v-model="searchFilter" id="itemCode">
          <option value="">선택</option>
          <option value="name">
            {{ isDentalLaboratory ? "기공소명" : "제조사명" }}
          </option>
          <option value="cNo">사업자등록번호</option>
        </select>
        <input
          type="text"
          placeholder="조건을 입력해주세요."
          v-model="condition"
          ref="cdInput"
          id=""
          autocomplete="off"
          @keyup.enter="enter()"
          :readonly="!isFocused"
          @focus="isFocused = true"
        />
        <div class="searchBtn">
          <img
            src="../../assets/img/search.png"
            alt="search"
            class="hoverPointer"
            @click="getManufacturersList(false)"
          />
        </div>
      </div>
    </div>
    <div class="filterWrap" style="">
      <div />
      <div class="searchinputbox">
        <select
          class="search-select"
          v-model="rowsPerPage"
          @change="handleRowsPerPage"
        >
          <option :value="10">10개씩 보기</option>
          <option :value="20">20개씩 보기</option>
          <option :value="50">50개씩 보기</option>
        </select>
      </div>
    </div>
    <div class="container-wrapper">
      <a-table
        class="ant-table-striped"
        size="small"
        v-if="responseData"
        :columns="columns"
        :data-source="responseData"
        :pagination="false"
        @resizeColumn="handleResizeColumn"
      >
        <template #emptyText>
          <div class="noResult">검색 결과가 없습니다.</div>
        </template>
      </a-table>
      <pagination
        :page-info="paginationData"
        page-name="CustomerManage"
        @change-page="paginationHandler"
      />
    </div>

    <!-- 삭제 모달 -->
    <div
      class="modal fade"
      id="deleteyesno"
      tabindex="-1"
      aria-labelledby="resetModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="justify-content: center !important"
      >
        <div
          class="modal-content"
          style="width: 70% !important; padding-top: 0.5vw"
        >
          <div class="modal-body" style="display: flex; flex-direction: column">
            <div style="text-align: center; padding-top: 1rem">
              <h4>{{ isDentalLaboratory ? "기공소" : "제조사" }} 삭제</h4>
              <h6>
                해당 {{ isDentalLaboratory ? "기공소" : "제조사" }}를
                삭제하시겠습니까?
              </h6>
            </div>
            <div
              style="display: flex; justify-content: center; margin-top: 2rem"
            >
              <button
                style="margin-right: 1vw"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                취소
              </button>
              <button
                type="button"
                class="btn btn-warning"
                @click="deleteManufacturer()"
              >
                삭제
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ManuInfoW :is-dental-laboratory="isDentalLaboratory" />
  <ManuInfoM
    :data="manufacturerDetailData"
    :is-dental-laboratory="isDentalLaboratory"
  />
  <hospital-acc-modal
    :selectedAccountInfo="selectedAccountInfo"
    @logout-user="logoutUser"
  />
  <RejectReasonModal
    :visible="rejectModalVisible"
    :company="selectedCompanyForReject"
    :loading="rejectLoading"
    @cancel="closeRejectModal"
    @submit="handleReject"
  />
  <!--
    제조사별 모바일 하단 탭 설정.
    계정별 권한(MenuManageModal)은 제조사 '계정 관리' 화면에 있고,
    이것은 설정 단위가 제조사이므로 '제조사 관리' 화면에 둔다.
  -->
  <mobile-tab-modal
    :show-modal="mobileTabModalOpen"
    :company-id="mobileTabCompanyId"
    :company-name="mobileTabCompanyName"
    @close-modal="closeMobileTabModal"
  />
  <!-- 목록 행 「지원 접속」 창(10-29) -->
  <support-entry-dialog
    v-model:open="supportOpen"
    :company-id="supportTarget.id"
    :company-type="supportTarget.type"
    :company-name="supportTarget.name"
  />
</template>
<script>
import supportEntryMixin from "@/mixins/supportEntryMixin";
import {
  convertDate,
  openDialog,
  businessNumberFormatter,
  phoneNumberFormatter,
  addCommaToNumber,
} from "@/utils/utils";
import jsonFile from "@/assets/locations.json";
import ManuInfoW from "@/views/components/ManuInfoW.vue";
import ManuInfoM from "@/views/components/ManuInfoM.vue";
import Pagination from "@/views/components/Pagination.vue";
import HospitalAccModal from "@/views/components/HospitalAccModal.vue";
import RejectReasonModal from "@/views/components/RejectReasonModal.vue";
import MobileTabModal from "@/views/MobileTabModal.vue";
import { MedicalDept } from "@/utils/enums";
import { YnEnum } from "@/enums/common.enums";

export default {
  mixins: [supportEntryMixin],
  name: "manuManage",
  components: {
    ManuInfoW,
    ManuInfoM,
    Pagination,
    HospitalAccModal,
    RejectReasonModal,
    MobileTabModal,
  },
  data() {
    return {
      addCommaToNumber,

      // 모바일 하단 탭 설정 모달
      mobileTabModalOpen: false,
      mobileTabCompanyId: "",
      mobileTabCompanyName: "",

      // 목록 받아오는 변수
      responseData: [],

      // 페이지네이션 관련 변수
      listSize: 0,
      rowsPerPage: 10, // Default, can be changed by the user
      page: 1,
      totalPages: 0, // Total number of pages, fetched from server
      pageSize: 0, // Same as totalPages
      paginationPageAmount: 10, // Default, can be variable
      paginationList: [],
      isFirstPage: true,
      isFirstBlock: true,
      isLastBlock: false,
      isLastPage: false,

      selectedManufacturer: "", // 선택한 제조사 id
      selectedManager: "", // 선택한 관리자 id
      manufacturerDetailData: {}, // 상세정보 데이터 넣는 객체
      selectedAccountInfo: {},

      isFocused: false, // 자동완성 때문에 최초엔 폴스로

      // 필터용 데이터
      deptList: [], // 과목 목록
      areaFirst: [], // 시군구 대분류
      areaSecond: [], // 시군구 중분류
      areaThird: [], // 읍면동 소분류
      selectedAreaFirst: "", // 선택된 시군구 대분류
      selectedAreaSecond: "", // 선택된 시군구 중분류
      selectedAreaThird: "", // 선택된 읍면동 소분류
      selectedDept: "", // 선택된 과
      deleteFilter: "", // 삭제 여부
      registrationStatusFilter: "", // 등록 상태 필터
      reapproving: {}, // 재승인 로딩 상태
      rejectModalVisible: false, // 거절 모달
      rejectLoading: false, // 거절 로딩 상태
      selectedCompanyForReject: null, // 거절할 회사 정보
      searchFilter: "name", // 필터 종류
      previousCondition: "", // 검색어
      condition: "", // 검색어

      paginationData: {
        currentPage: 1,
        totalPages: 0,
      },
      columns: [
        {
          key: "medicalDept",
          title: "진료 과목",
          dataIndex: "medicalDept",
          align: "center",
          customRender: ({ text, record }) => {
            const medicalDept = record.medicalDept.filter(
              (item) => item !== MedicalDept.COMMON
            );
            return this.convertDeptsToString(medicalDept);
          },
        },
        {
          key: "name",
          title: this.isDentalLaboratory ? "기공소명" : "제조사명",
          dataIndex: "name",
          align: "center",
        },
        {
          key: "cNo",
          title: "사업자등록번호",
          dataIndex: "cNo",
          align: "center",
        },
        {
          key: "registrationStatus",
          title: "등록상태",
          dataIndex: "registrationStatus",
          align: "center",
          width: 100,
          customRender: ({ record }) => {
            const status = record.registrationStatus;
            if (status === "REJECTED") {
              return (
                <a-tooltip title={record.rejectionReason || "거절 사유 없음"}>
                  <a-tag color="red">거절됨</a-tag>
                </a-tooltip>
              );
            } else if (status === "PENDING") {
              return <a-tag color="orange">승인대기</a-tag>;
            } else {
              return <a-tag color="green">활성</a-tag>;
            }
          },
        },
        {
          key: "isTestCompany",
          title: `테스트 ${this.isDentalLaboratory ? "기공소" : "제조사"} 여부`,
          dataIndex: "isTestCompany",
          align: "center",
          customRender: ({ record }) => {
            return record.isTestCompany === YnEnum.Y ? "예" : "아니오";
          },
        },
        {
          key: "accountInfo_name",
          title: "관리자명",
          dataIndex: "accountInfo_name",
          align: "center",

          customRender: ({ record }) => (
            <div>
              {record.accountInfo_name.map((name, index) => (
                <div key={index}>{name}</div>
              ))}
            </div>
          ),
        },
        {
          key: "accountInfo_mobile",
          title: "연락처",
          dataIndex: "accountInfo_mobile",
          align: "center",

          customRender: ({ record }) => (
            <div>
              {record.accountInfo_mobile.map((mobile, index) => (
                <div key={index}>{mobile}</div>
              ))}
            </div>
          ),
        },
        {
          key: "accountInfo_username",
          title: "관리자 이메일",
          dataIndex: "accountInfo_username",
          align: "center",

          customRender: ({ record }) => (
            <div>
              {record.accountInfo_username.map((username, index) => (
                <div key={index}>{username}</div>
              ))}
            </div>
          ),
        },
        {
          key: "manage",
          title: "관리",
          dataIndex: "manage",
          align: "center",
          customRender: ({ record }) => {
            if (record.deleteYn === "N") {
              return (
                <div style="display: flex; gap: 8px; justify-content: center;">
                  {record.registrationStatus === "PENDING" && (
                    <>
                      <div
                        type="button"
                        class="certi-custom-btn certi-custom-btn-success"
                        onClick={() => {
                          this.handleApprove(record);
                        }}
                      >
                        {this.reapproving[record._id] ? "처리중..." : "승인"}
                      </div>
                      <div
                        type="button"
                        class="certi-custom-btn certi-custom-btn-danger"
                        onClick={() => {
                          this.openRejectModal(record);
                        }}
                      >
                        거절
                      </div>
                    </>
                  )}
                  {record.registrationStatus === "REJECTED" && (
                    <div
                      type="button"
                      class="certi-custom-btn certi-custom-btn-success"
                      onClick={() => {
                        this.handleApprove(record);
                      }}
                    >
                      {this.reapproving[record._id] ? "처리중..." : "승인"}
                    </div>
                  )}
                  {this.canSupportEntry && (
                    <div
                      type="button"
                      class="certi-custom-btn"
                      onClick={() => {
                        this.openSupport(record, this.isDentalLaboratory ? "DENTAL_LABORATORY" : "MANUFACTURER");
                      }}
                    >
                      지원 접속
                    </div>
                  )}
                  <div
                    data-bs-toggle="modal"
                    data-bs-target="#manufacturerInfoMModal"
                    class="certi-custom-btn"
                    onClick={() => {
                      this.getManufacturerDetail(record._id);
                    }}
                  >
                    수정
                  </div>
                  <div
                    class="certi-custom-btn"
                    onClick={() => {
                      this.openMobileTabModal(record);
                    }}
                  >
                    하단 탭 설정
                  </div>
                  <div
                    data-bs-toggle="modal"
                    data-bs-target="#deleteyesno"
                    class="certi-custom-btn"
                    onClick={() => {
                      this.selectManufacturer(record);
                    }}
                  >
                    삭제
                  </div>
                </div>
              );
            } else {
              return <div style="color: red !important;">삭제됨</div>;
            }
          },
        },
      ],
    };
  },
  computed: {
    isDentalLaboratory() {
      return this.$route.path.includes("/dental-laboratory");
    },
  },
  watch: {
    $route(to, from) {
      // 라우트가 변경될 때마다 API 다시 호출
      this.paginationData.currentPage = 1;
      this.initFilter(); // 필터도 초기화
      const obj = {};
      obj.page = this.paginationData.currentPage;
      this.paginationHandler(obj);
    },
  },
  async mounted() {
    this.isFocused = false;
    this.getAreaList();
    await this.getDeptList();
    this.searchFilter = "name"; // 초기 검색 필터 명시적 설정
    const obj = {};
    obj.page = this.paginationData.currentPage;
    await this.paginationHandler(obj);
  },
  methods: {
    businessNumberFormatter,
    phoneNumberFormatter,

    /**
     * 모바일 하단 탭 설정 모달을 연다.
     *
     * 계정별 권한 관리(MenuManageModal)는 username 을 넘기지만
     * 여기는 설정 단위가 제조사라 companyId 를 넘긴다.
     * 실제 설정 로드는 모달이 showModal 을 watch 해서 처리한다.
     */
    openMobileTabModal(record) {
      this.mobileTabCompanyId = record._id;
      this.mobileTabCompanyName = record.name || "";
      this.mobileTabModalOpen = true;
    },
    closeMobileTabModal() {
      this.mobileTabModalOpen = false;
      this.mobileTabCompanyId = "";
      this.mobileTabCompanyName = "";
    },

    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getManufacturersList();
    },

    handleResizeColumn(w, col) {
      col.width = w;
    },

    // 주요 API

    // 과 목록 가져오기
    async getDeptList() {
      try {
        const response = await this.$apiInstance.get(`/items/medical/depts`);
        if (response.status === 200 || response.status === 201) {
          this.deptList = response.data.filter(
            (item) => item.code !== MedicalDept.COMMON
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 과목 코드를 이름으로 변환
    convertDeptToText(code) {
      const department = this.deptList.find((item) => item.code === code);
      return department ? department.name : "-";
    },
    // 과목명 가공
    convertDeptsToString(array) {
      let deptString = "";
      if (array && array.length > 0) {
        for (const dept of array) {
          deptString += `${this.convertDeptToText(dept)} / `;
        }
        return deptString.slice(0, -2);
      } else {
        return "-";
      }
    },
    // 제조사 목록 가져오기
    async getManufacturersList() {
      const obj = {};
      if (this.previousCondition !== this.condition) {
        obj.page = 1;
      } else {
        obj.page = this.paginationData.currentPage;
      }
      obj.limit = this.rowsPerPage; // 페이지네이션 관련 변수
      obj.type = this.isDentalLaboratory ? "DENTAL_LABORATORY" : "MANUFACTURER";
      // if(this.selectedDept) obj.medicalDept = this.selectedDept;
      if (this.selectedAreaFirst) obj.addrOne = this.selectedAreaFirst;
      if (this.selectedAreaSecond) obj.addrTwo = this.selectedAreaSecond;
      if (this.selectedAreaThird) obj.addrThree = this.selectedAreaThird;
      if (this.deleteFilter) obj.deleteYn = this.deleteFilter;
      if (this.registrationStatusFilter)
        obj.registrationStatus = this.registrationStatusFilter;
      if (this.searchFilter) obj.search = this.searchFilter;
      if (this.condition) obj.condition = this.condition;

      try {
        const response = await this.$apiInstance.post(
          `/companies/list/v2`,
          obj
        );
        if (response.status === 200 || response.status === 201) {
          if (this.previousCondition !== this.condition) {
            this.paginationData.currentPage = 1;
          }
          this.previousCondition = this.condition;
          this.responseData = response.data.docs;
          this.listSize = response.data.totalDocs;
          this.paginationData.totalPages = response.data.totalPages;

          for (let i = 0; i < this.responseData.length; i++) {
            this.responseData[i].index =
              this.listSize -
              i -
              (this.paginationData.currentPage - 1) * this.rowsPerPage;
            this.responseData[i].formattedAddress = this.formatAddress(
              this.responseData[i]
            );
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getManufacturersList();
    },
    formatAddress(input) {
      const firstText = input.addrOne ? input.addrOne : "";
      const secondText = input.addrTwo ? input.addrTwo : "";
      const thirdText = input.addrThree ? input.addrThree : "";
      const combinedText = `${firstText} ${secondText} ${thirdText}`;
      if (combinedText.trim().length === 0) return "-";
      return combinedText;
    },
    // 제조사 삭제
    async deleteManufacturer() {
      try {
        const response = await this.$apiInstance.delete(
          `/companies/${this.selectedManufacturer}`
        );
        if (response.status === 200 || response.status === 201) {
          await openDialog(
            `해당 ${
              this.isDentalLaboratory ? "기공소" : "제조사"
            } 정보가 삭제되었습니다.`,
            "success",
            "확인"
          ).then(() => {
            location.reload();
          });
        } else {
          await openDialog(
            `${
              this.isDentalLaboratory ? "기공소" : "제조사"
            } 정보 삭제에 실패하였습니다.`,
            "error",
            "확인"
          );
        }
      } catch (error) {
        console.log(error);
        await openDialog(
          `${
            this.isDentalLaboratory ? "기공소" : "제조사"
          } 정보 삭제에 실패하였습니다.`,
          "error",
          "확인"
        );
      }
    },
    async logoutUser(accountInfoObj) {
      const obj = {};
      obj.companyId = accountInfoObj.companyId;
      obj.username = accountInfoObj.username;
      try {
        const confirmResult = await confirmDialog(
          this.$i18n.t("hospitalacc_logout_btn"),
          this.$i18n.t("hospitalacc_logout_content")
        );
        if (confirmResult) {
          const response = await this.$apiInstance.post(
            `/accounts/target/logout`,
            obj
          );
          if (response.status === 200 || response.status === 201) {
            await oneBtnDialog(
              this.$i18n.t("hospital_logout_done_title"),
              this.$i18n.t("hospital_logout_done_content"),
              false
            );
            this.selectedAccountInfo.isLoggedIn = false;
          }
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(
          this.$i18n.t("hospital_logout_fail_title"),
          this.$i18n.t("hospital_logout_fail_content"),
          false
        );
      }
    },
    async getAccountInfo(item, username) {
      const companyId = item._id;
      try {
        const response = await this.$apiInstance.get(
          `/accounts/history/${companyId}/${username}`
        );
        if (response.status === 200 || response.status === 201) {
          this.selectedAccountInfo = response.data;
          this.selectedAccountInfo.companyId = companyId;
          this.selectedAccountInfo.username = username;
          if (response?.data?.refreshToken) {
            this.selectedAccountInfo.isLoggedIn = true;
          } else {
            this.selectedAccountInfo.isLoggedIn = false;
          }
        }
        console.log(this.selectedAccountInfo);
      } catch (error) {
        console.log(error);
        // await oneBtnDialog(this.$i18n.t('hospital_pwinit_fail_title'),this.$i18n.t('hospital_pwinit_fail_content'), false);
      }
    },
    // 제조사 정보 상세
    async getManufacturerDetail(id) {
      try {
        const response = await this.$apiInstance.get(`/companies/${id}`);
        if (response.status === 200 || response.status === 201) {
          this.manufacturerDetailData = response.data;
          this.manufacturerDetailData.manufacturerId = id;
          this.manufacturerDetailData.isTestCompany =
            response.data.isTestCompany === YnEnum.Y ? true : false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 비밀번호 초기화
    async resetPassword() {
      try {
        const response = await this.$apiInstance.put(
          `/companies/resetPassword/${this.selectedManager}`
        );
        if (response.status === 200 || response.status === 201) {
          await openDialog(
            "비밀번호가 초기화되었습니다.",
            "success",
            "확인"
          ).then(() => {
            location.reload();
          });
        } else {
          await openDialog(
            "비밀번호 초기화에 실패하였습니다.",
            "error",
            "확인"
          );
        }
      } catch (error) {
        await openDialog("비밀번호 초기화에 실패하였습니다.", "error", "확인");
        console.log(error);
      }
    },

    // 기타 ManuManage용 utils

    // 엔터 눌렀을 때 실행
    async enter() {
      if (this.searchFilter === "") {
        await openDialog("검색 필터를 선택해 주세요.", "error", "확인");
      } else {
        this.paginationData.currentPage = 1;
        this.getManufacturersList();
      }
    },

    // 지역 목록 가져오기
    getAreaList() {
      this.areaFirst = Object.keys(jsonFile).sort((a, b) =>
        a.localeCompare(b, "ko-KR")
      );
      this.selectedAreaFirst = "";
      this.selectedAreaSecond = "";
      this.selectedAreaThird = "";
    },

    // 시도 변화에 따른 시군구 값 넣기
    areaSecondChange() {
      if (this.selectedAreaFirst) {
        const secondLevelData = jsonFile[this.selectedAreaFirst];
        this.selectedAreaSecond = "";
        this.selectedAreaThird = "";
        this.areaSecond = Object.keys(secondLevelData).sort((a, b) =>
          a.localeCompare(b, "ko-KR")
        );
        this.areaThird = [];
      } else {
        this.selectedAreaSecond = "";
        this.selectedAreaThird = "";
        this.areaSecond = [];
        this.areaThird = [];
      }
      this.paginationData.currentPage = 1;
      this.getManufacturersList();
    },

    // 시군구 변화에 따른 읍면동 값 넣기
    areaThirdChange() {
      if (this.selectedAreaSecond) {
        const thirdLevelData =
          jsonFile[this.selectedAreaFirst][this.selectedAreaSecond];
        this.areaThird = Object.keys(thirdLevelData).sort((a, b) =>
          a.localeCompare(b, "ko-KR")
        );
        this.selectedAreaThird = "";
      } else {
        this.selectedAreaThird = "";
        this.areaThird = [];
      }
      this.paginationData.currentPage = 1;
      this.getManufacturersList();
    },

    // 필터 초기화
    initFilter() {
      this.paginationData.currentPage = 1;
      this.selectedAreaFirst = "";
      this.selectedAreaSecond = "";
      this.selectedAreaThird = "";
      this.deleteFilter = "";
      this.registrationStatusFilter = "";
      this.condition = "";
      this.searchFilter = "name";
      this.getManufacturersList();
    },

    // 승인 처리
    async handleApprove(record) {
      this.reapproving[record._id] = true;
      try {
        const response = await this.$apiInstance.patch(
          `/companies/signup/approve/${record._id}`
        );
        if (response.status === 200 || response.status === 201) {
          await openDialog(
            `${record.name}의 가입이 승인되었습니다.`,
            "success",
            "확인"
          );
          await this.getManufacturersList();
        }
      } catch (error) {
        console.error("승인 실패:", error);
        await openDialog(
          error.response?.data?.message || "승인 처리에 실패했습니다.",
          "error",
          "확인"
        );
      } finally {
        this.reapproving[record._id] = false;
      }
    },

    // 거절 모달 열기
    openRejectModal(record) {
      this.selectedCompanyForReject = record;
      this.rejectModalVisible = true;
    },

    // 거절 모달 닫기
    closeRejectModal() {
      this.rejectModalVisible = false;
      this.selectedCompanyForReject = null;
    },

    // 거절 처리
    async handleReject(reason) {
      this.rejectLoading = true;
      try {
        const response = await this.$apiInstance.patch(
          `/companies/signup/reject/${this.selectedCompanyForReject._id}`,
          { reason }
        );
        if (response.status === 200 || response.status === 201) {
          await openDialog(
            `${this.selectedCompanyForReject.name}의 가입이 거절되었습니다.`,
            "success",
            "확인"
          );
          this.closeRejectModal();
          await this.getManufacturersList();
        }
      } catch (error) {
        console.error("거절 실패:", error);
        await openDialog(
          error.response?.data?.message || "거절 처리에 실패했습니다.",
          "error",
          "확인"
        );
      } finally {
        this.rejectLoading = false;
      }
    },

    // 날짜, 시간 포맷에 맞추기
    convertDate,

    // 보기, 수정, 삭제 시 선택
    selectManufacturer(manufacturer) {
      this.selectedManufacturer = manufacturer._id;
      this.selectedManager = manufacturer.accountInfo_id;
    },
  },
};
</script>
